module.exports = __webpack_public_path__ + "img/interactive_platform_1.2cfcb79e.png";